import React from 'react';
import { Button } from '../controls/Button.jsx';

/* Guided Mode's opening element on every metric-bearing screen. Verdict before
   evidence. NEVER coloured by sentiment — a red verdict panel would make bad news
   scannable and therefore skippable. Two or three findings, never a list of ten.
   Expert Mode collapses it to one line. */

export function VerdictPanel({ verdict, findings = [], action, onAction, rules = [], collapsed = false, style }) {
  if (collapsed) {
    return (
      <div style={{
        padding: 'var(--space-8) var(--space-16)', background: 'var(--bg-surface)',
        border: '1px solid var(--border-default)', borderRadius: 'var(--radius-panel)',
        fontSize: 'var(--body-sm-size)', color: 'var(--text-primary)', ...style,
      }}>{verdict}</div>
    );
  }
  return (
    <section style={{
      display: 'flex', flexDirection: 'column', gap: 'var(--space-12)',
      padding: 'var(--pad-panel)', background: 'var(--bg-surface)',
      border: '1px solid var(--border-default)', borderRadius: 'var(--radius-panel)', ...style,
    }}>
      <h2 style={{
        margin: 0, fontSize: 'var(--heading-size)', lineHeight: 'var(--heading-line)',
        fontWeight: 'var(--heading-weight)', color: 'var(--text-primary)',
      }}>{verdict}</h2>

      {findings.length ? (
        <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 'var(--space-8)' }}>
          {findings.slice(0, 3).map((t, i) => (
            <li key={i} style={{
              display: 'flex', gap: 'var(--space-8)', fontSize: 'var(--body-size)',
              lineHeight: 'var(--body-line)', color: 'var(--text-secondary)', maxWidth: 'var(--measure-prose)',
            }}><span aria-hidden="true" style={{ color: 'var(--text-tertiary)' }}>·</span><span>{t}</span></li>
          ))}
        </ul>
      ) : null}

      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-16)' }}>
        {rules.length ? (
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: 'var(--caption-size)', color: 'var(--text-tertiary)' }}>
            Rules: {rules.join(', ')}
          </span>
        ) : null}
        {action ? <span style={{ marginLeft: 'auto' }}><Button onClick={onAction} iconRight="arrow-right">{action}</Button></span> : null}
      </div>
    </section>
  );
}
